<template>
  <div class="map-old">
    <img :src="mapimg" class="map-bg" alt="">
    <!-- <div class="map-picker">
      <van-popup title="选择城市" @on-change="getName" :data="citylist" :columns="2" v-model="value4" show-name></van-popup>
    </div> -->
    <div class="map-field">
      <van-field class="map-picker" readonly clickable :value="value" placeholder="请选择城市" @click="showPicker = true"
        right-icon="arrow"
      />
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" :loading="cityLoading" @cancel="showPicker = false" @confirm="onConfirm" @change="Changecity" />
    </van-popup>
    <div class="project-count">
        <div class="hd">截至目前择美同行患者援助项目</div>
        <div class="bd">
            <div class="count-item">
                <div class="iconfont  s1"> </div>
                <div class="sum">{{num.city}}</div>
                <div class="title">覆盖城市</div>
            </div>
            <div class="count-item">
                <div class="iconfont  s2"> </div>
                <div class="sum">{{num.hospital}}</div>
                <div class="title">覆盖医院</div>
            </div>
            <div class="count-item">
                <div class="iconfont  s3"></div>
                <div class="sum">{{num.drugstore}}</div>
                <div class="title">覆盖药房</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// import { PopupPicker, Group, Tab, TabItem, Value2nameFilter as value2name, } from 'vux'
// import Search from 'vue-baidu-map/components/search/LocalSearch'
import { GetProvince, GetCity, getMapCount} from "../../api/api";
import Vue from "vue";
import { CouponList, Toast } from 'vant';
import mapimg from '@/assets/china.png'
Vue.use(Toast);

export default {
    data () {
    return {
      mapimg:mapimg,//图片
      value:"",
      showPicker:false,
      columns: [
        {
          values: []
        },
        // 第二列
        {
          values: []
        }
      ],
      cityLoading: false,
      ProvinceArr:[],
      province:"",
      CityArr:[],
      city:"",
      num:{city:"",hospital:"",drugstore:""},
    }
  },
  mounted() {
    // this.type = this.$route.query.type?this.$route.query.type:''
    // if (this.type == 'h') {
    //   this.activeType = this.list2[0].title
    // } else if (this.type == 'd') {
    //   this.activeType = this.list2[1].title
    // }
    this.getProvince();
    this.getCount();
  },
  methods: {
    async getProvince() {
      let pres = null;
      pres = await GetProvince()
      const parr = pres.data
      this.ProvinceArr = []
      this.ProvinceArr = Object.values(parr)
      this.province = this.ProvinceArr[0]
      this.getCity();
      this.columns[0].values = this.ProvinceArr;
    },
    async getCity() {
      // Toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true
      // });
      this.cityLoading = true
      this.CityArr = []
      let cres = null;
      cres = await GetCity({province: this.province})
      const carr = cres.data
      this.CityArr = Object.values(carr)
      this.columns[1].values = this.CityArr;
      // Toast.clear();
      this.cityLoading = false
    },
    async getCount(){//获取记数
      let pres = null;
      pres = await getMapCount()
      const parr = pres.data
      this.num.city=parr.city_count
      this.num.hospital=parr.hospital_count
      this.num.drugstore=parr.drugstore_count
      console.log("getCount",parr)
    },
    onConfirm(value) {
      if (this.cityLoading) {
        return
      }
      // if(value){//关闭该省市下暂无数据
      //   this.showmessage = false
      // }
      this.province = value[0]
      this.city = value[1]
      // this.value = value[0]+','+value[1]
      this.showPicker = false;
      this.$router.push({name:"MapDetail",query:{province:this.province,city:this.city}})
      // this.gethospital(value[0],value[1])
      // this.getDrugstore(value[0],value[1])
      // this.center = value[1]
    },
    Changecity(picker, values) {
      this.province = values[0]
      this.getCity()
    },





    // getProvinceCity(){
    //   this.$http.post('pap/get-province-city', {},{params:{project_id:this.$route.params.project_id}})
    //     .then(response=>{
    //       this.citylist = response.data
    //     }).catch(error => {
    //       console.log(error);
    //     })
    // },
    // getName (value) {      
    //   let data = value2name(value, this.citylist)
    //   let arr = data.split(''),index = arr.indexOf(' ')
    //   let province = '',city = ''
    //   for (let i = 0; i < arr.length; i++) {
    //     if(i<index){
    //       province += arr[i]
    //     }else if(i>index){
    //       city += arr[i]
    //     }
    //   }    
    //   if(city!='' && province != ''){

    //     this.$router.push({name:'map-view',query:{province: province,city:city }})
    //   }
    // },
   
    //获取数目
    // fetchHospital(){
    //  this.$http.post('pap/result')
    //     .then(response=>{  
    //       this.num = response.data.data.num
    //       console.log('response.data.volunteer',this.num);
    //     }).catch(error => {
    //       console.log(error);
    //     })
    // },
  },

}
</script>

<style lang='less'>
.map-old {
  background: linear-gradient(#30AAD5, #3BC1F0) center center no-repeat; 
  min-height: 100vh; 
  overflow-y: scroll; 
  .map-field {
    position: absolute !important;
    top: 20px;
    left: 0;
    width: 100%;
    .map-picker {
      width: 90%;
      margin: 0 auto;
      border-radius: 50px;
    }
  }
  .map-bg {
    position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 0; margin: auto; width: 100%;
  }
  .map-picker {
    position: absolute !important; top: 20px; left: 15px; right: 15px;
    .weui-cells {
      border-radius: 44px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.07); color: @purple;
      &:first-child {
        margin-top: 0 !important;
      }
      &:before,&:after {
        display: none;
      }
    }
  }
  .project-count {
    position: absolute !important; 
    bottom: 40px; 
    left: 15px; 
    right: 15px; 
    background: rgba(0, 0, 0, 0.1); 
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.07); 
    border-radius: 5px; 
    // color: #555; z-index: 10;
    color:white;
    .hd {
      position: relative; 
      padding: 10px 15px; 
      font-size: 16px; 
      line-height: 24px; 
      text-align: center; 
      // color: darken(@purple, 10%); 
      // text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.7);
      &::after {
        .b-line; left: 15px; right: 15px; border-color: rgba(255, 255, 255, 0.3);
      }
      .iconfont {
        position: absolute; top: -3px; right: 15px; font-size: 36px; color: @red;
      }
    }
    .bd {
      .display-flex; padding: 15px;
      .count-item {
        display: flex;
        flex-flow: column nowrap;
        align-items:center;
        .flex-1; text-align: center;
        .sum { font-size: 20px; 
        // color: darken(@purple, 10%); 
        // text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.7);
        }
        .title { font-size: 12px; color: #fff;}
        .iconfont {
          width: 75px; 
          height: 75px; 
          line-height: 75px; 
          font-size: 48px; 
          background: rgba(255, 255, 255, 0.1); 
          border-radius: 10px; 
          // background: #fff; 
          // border-radius: 75px; 
          margin: 0 0 5px;
          &.s1 { color: #4BC973;background:url(../../assets/city.png); background-size:90px 75px; background-repeat:no-repeat;background-position:center;}
          &.s2 { color: #F39C60;background:url(../../assets/hospital.png); background-size:90px 75px; background-repeat:no-repeat;background-position:center;}
          &.s3 { color: #5BC9F7;background:url(../../assets/drugstore.png); background-size:90px 75px; background-repeat:no-repeat;background-position:center;}
        }
      }
    }
  }
}
.result-box {
  position: absolute !important; bottom: 10px; left: 10px; right: 10px; background: #fff; box-shadow: 0 0 10px rgba(0, 0, 0, 0.07); border-radius: 5px; color: #555;
  .vux-slider > .vux-swiper {
    overflow: initial;
    .vux-swiper-item {
      overflow: auto;
    }
  }
  .result-list {
    padding: 10px 15px;
    .item {
      position: relative; padding: 8px 0; font-size: 1.4rem;
      &::after {
        .b-line;
      }
      &::after:last-child { display: none;}
    }
  }
  .result-ft {
    position: relative; padding: 10px; text-align: center; color: #999; font-size: 14px;
    &::before {
      .t-line;
    }
    .vux-x-icon {
      fill: #999; vertical-align: -2px;
    }
  }
}

</style>
